var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entity-child-layout"},[_c('main',{staticClass:"entity-child-layout__main"},[_c('el-card',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }